export const getMaintenanceServices = state => state.maintenance;



// WEBPACK FOOTER //
// ./src/store/reducers/maintenance/selectors.js